import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import {
  Box, Card, CardContent, TextField, Button,
  Typography, Alert, CircularProgress, Divider
} from "@mui/material";
export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
    } catch {
      setError("Incorrect email or password. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #003366 0%, #005499 50%, #0077cc 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: 2
    }}>
      <Card sx={{ maxWidth: 400, width: "100%", borderRadius: 3, boxShadow: 10 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <img
              src="/SynaptixLogo_final.png"
              alt="Synaptix by Alteram"
              style={{ width: "85%", objectFit: "contain", marginBottom: 12 }}
            />
            <Divider sx={{ mb: 2 }} />
            <Typography variant="h6" fontWeight={600} color="#003366">
              Synaptix Training Platform
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              Sign in to continue your training
            </Typography>
          </Box>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <form onSubmit={handleLogin}>
            <TextField
              fullWidth label="Email Address" type="email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              margin="normal" required autoFocus sx={{ mb: 2 }}
            />
            <TextField
              fullWidth label="Password" type="password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              margin="normal" required sx={{ mb: 3 }}
            />
            <Button
              fullWidth type="submit" variant="contained" size="large"
              disabled={loading}
              sx={{
                py: 1.5, borderRadius: 2, fontSize: 16, fontWeight: 600,
                background: "linear-gradient(135deg, #003366, #005499)",
                "&:hover": { background: "linear-gradient(135deg, #005499, #0077cc)" }
              }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "SIGN IN"}
            </Button>
          </form>
          <Typography variant="caption" color="text.secondary"
            display="block" textAlign="center" mt={3}>
            © 2026 Alteram Solutions PTY LTD. All rights reserved.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
